import type { TMessages } from '@/types/TMessages'

export const messages = {
  title: 'Для кого?',
  requirements: { title: 'Требования к заявителю:' },
  legalEntity: 'Юридическое <br/>лицо',
  physicPerson: 'Индивидуальный предприниматель',
} satisfies TMessages
